import { EConfirmPhoneStatus, ESendSmsStatus } from '../../types/registration';
export function sendSmsStatusSelector(state) {
  return state.registration.sendSms.status;
}
export function isConfirmPhoneFormSubmittingSelector(state) {
  return state.registration.confirmPhone.status === EConfirmPhoneStatus.Loading || state.registration.sendSms.status === ESendSmsStatus.Loading;
}
export function hasCodeErrorSelector(state) {
  var _state$registration$c = state.registration.confirmPhone,
      status = _state$registration$c.status,
      error = _state$registration$c.error;
  var _state$registration$s = state.registration.sendSms,
      smsStatus = _state$registration$s.status,
      smsError = _state$registration$s.error;
  return status === EConfirmPhoneStatus.Failed && error !== undefined || smsStatus === ESendSmsStatus.Failed && smsError !== undefined;
}
export function codeErrorSelector(state) {
  return hasCodeErrorSelector(state) ? state.registration.confirmPhone.error || state.registration.sendSms.error : undefined;
}
export function viewDataPhoneSelector(state) {
  return state.view.data.phone;
}
export function viewDataEmailSelector(state) {
  return state.view.data.email;
}